import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=b66bab32&"
import script from "./footer.vue?vue&type=script&lang=js&"
export * from "./footer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b66bab32')) {
      api.createRecord('b66bab32', component.options)
    } else {
      api.reload('b66bab32', component.options)
    }
    module.hot.accept("./footer.vue?vue&type=template&id=b66bab32&", function () {
      api.rerender('b66bab32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/pages/dataImport/components/footer.vue"
export default component.exports